import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { usePetitionGuidesCategoryPageData } from '#src/app/pages/petitionGuides/category/details/pageContext';

export const PageHeading: React.FC = () => {
	const {
		data: { name, introParagraph },
	} = usePetitionGuidesCategoryPageData();

	return (
		<div className="text-typography-strong container space-y-2 pt-6 md:pt-10">
			<Text className="text-typography-weak">
				<Translate value="corgi.petition_guides_category_page.page_heading.subtitle" />
			</Text>

			<Text as="h1" variant="heading" size="x-large">
				{name ?? <Translate value="corgi.petition_guides_category_page.page_heading.title" />}
			</Text>

			<Text as="p" className="max-w-2xl">
				{introParagraph || <Translate value="corgi.petition_guides_category_page.page_heading.description" />}
			</Text>
		</div>
	);
};
